var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2227 10.9302C8.50673 13.451 10.5578 15.4995 13.0808 16.7821L15.0371 14.8218C15.2824 14.5765 15.632 14.5065 15.9396 14.6043C16.9329 14.9327 18.0046 15.111 19.111 15.111C19.6042 15.111 20 15.5068 20 16V19.111C20 19.6042 19.6042 20 19.111 20C10.7639 20 4 13.2364 4 4.88897C4 4.39835 4.39835 4 4.88897 4H8C8.49318 4 8.88897 4.39579 8.88897 4.88897C8.88897 5.99542 9.06728 7.06746 9.3957 8.06224C9.49345 8.36796 9.42352 8.72018 9.17821 8.96549L7.2227 10.9305V10.9302Z",
    fill: "#7D7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/Contact.eb2d22488ef040b7b60fd1ce284df555.svg";
export { ForwardRef as ReactComponent };